/**
 * Caricamento foto per la card: orientamento EXIF rispettato, downscale
 * PRIMA del rendering (memoria sotto controllo su iPhone), nessun upload.
 * Il risultato è un canvas: ridisegnare la foto elimina per costruzione
 * ogni metadato EXIF/geotag dall'immagine esportata.
 */

const MAX_SIDE = 1920; // basta per coprire il lato lungo della card

/**
 * @param {File} file immagine da input camera/galleria
 * @returns {Promise<HTMLCanvasElement>} foto orientata e ridimensionata
 */
export const loadPhotoFromFile = async (file) => {
  let source;
  let width;
  let height;

  // createImageBitmap con 'from-image' applica l'orientamento EXIF ed è
  // la via più efficiente in memoria; fallback su <img> (i browser moderni
  // applicano comunque l'orientamento EXIF in decodifica).
  if (typeof createImageBitmap === 'function') {
    try {
      source = await createImageBitmap(file, { imageOrientation: 'from-image' });
      width = source.width;
      height = source.height;
    } catch (e) {
      source = null;
    }
  }
  if (!source) {
    source = await new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Immagine non leggibile')); };
      img.src = url;
    });
    width = source.naturalWidth;
    height = source.naturalHeight;
  }

  const scale = Math.min(1, MAX_SIDE / Math.max(width, height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);

  if (source.close) source.close(); // libera l'ImageBitmap
  return canvas;
};
